import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'ng2-select';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { DatePipe } from '@angular/common';

import { MemberService } from './services/Member.service';

//import { MemberExplorerComponent } from './Member/MemberExplorer.component';
//import { MemberProfileComponent } from './Member/MemberProfile.component';
//import { GenerateEPinComponent } from './Member/GenerateEPin.component';
//import { TransferEPinComponent } from './Member/TransferEPin.component';
//import { BankDetailComponent } from './Member/BankDetail.component';
//import { ChangePasswordComponent } from './Member/ChangePassword.component';
//import { MemberChangePasswordComponent } from './Member/MemberChangePassword.component';
//import { MemberPasswordListComponent } from './Member/MemberPasswordList.component';
//import { DirectTreeViewComponent } from './Member/DirectTreeView.component';
//import { TreeViewComponent } from './Member/TreeView.component';
//import { EpinStatusComponent } from './Member/EpinStatus.component';
//import { MemberActivateComponent } from './Member/MemberActivate.component';
//import { AllTeamComponent } from './Member/AllTeam.component';
//import { BinaryMatchingComponent } from './Member/BinaryMatching.component';
//import { DirectLevelMatchingComponent } from './Member/DirectLevelMatching.component';
//import { CompanyTurnOverComponent } from './Member/CompanyTurnOver.component';
//import { WalletHistory } from './Member/WalletHistory.component';
//import { Payment } from './Member/Payment.component';
//import { PaymentGOI } from './Member/PaymentGOI.component';
//import { PaymentHistory } from './Member/PaymentHistory.component';
//import { GOIIncome } from './Member/GOIIncome.component';
//import { GOIIncomeMonthly } from './Member/GOIIncomeMonthly.component';
//import { TDS } from './Member/TDS.component';
//import { RepurchaseWallet } from './Member/RepurchaseWallet.component';
//import { WithdrawalRequestApproval } from './Member/WithdrawalRequestApproval.component';
//import { WithdrawalRequest } from './Member/WithdrawalRequest.component';
//import { WithdrawalHistory } from './Member/WithdrawalHistory.component';
//import { MemberRegistrationRequest } from './Member/MemberRegistrationRequest.component';
//import { RegistrationRequestApproval } from './Member/RegistrationRequestApproval.component';
//import { Plan1 } from './Member/Plan1.component';
//import { Plan2 } from './Member/Plan2.component';
//import { Plan3 } from './Member/Plan3.component';
//import { Plan4 } from './Member/Plan4.component';
//import { DonationSlip } from './Member/DonationSlip.component';
//import { DonationReceive } from './Member/DonationReceive.component';
//import { WelcomeLetter } from './Member/WelcomeLetter.component';
//import { EditProfile } from './Member/EditProfile.component';
//import { EditBankDetails } from './Member/EditBankDetails.component';
//import { RenewRequest } from './Member/RenewRequest.component';
//import { UpgradeRequest } from './Member/UpgradeRequest.component';
//import { SendDonationReport } from './Member/SendDonationReport.component';
//import { ReceiveDonationReport } from './Member/ReceiveDonationReport.component';
//import { RegistrationRequestHistory } from './Member/RegistrationRequestHistory.component';
//import { GenerateSlip } from './Member/GenerateSlip.component';
//import { BoosterIncomeWallet } from './Member/BoosterIncomeWallet.component';
//import { EpinReceiveTransfer } from './Member/EpinReceiveTransfer.component';











@NgModule({
  declarations: [
    AppComponent,
    //HomeComponent,
    //MemberExplorerComponent,
    //MemberProfileComponent,
    //GenerateEPinComponent,
    //TransferEPinComponent,
    //BankDetailComponent,
    //ChangePasswordComponent,
    //MemberChangePasswordComponent,
    //MemberPasswordListComponent,
    //DirectTreeViewComponent,
    //TreeViewComponent,
    //EpinStatusComponent,
    //MemberActivateComponent,
    //AllTeamComponent,
    //BinaryMatchingComponent,
    //DirectLevelMatchingComponent,
    //CompanyTurnOverComponent,
    //WalletHistory,
    //Payment,
    //PaymentGOI,
    //PaymentHistory,
    //GOIIncome,
    //GOIIncomeMonthly,
    //TDS,
    //RepurchaseWallet,
    //WithdrawalRequestApproval,
    //WithdrawalHistory,
    //WithdrawalRequest,
    //MemberRegistrationRequest,
    //RegistrationRequestApproval,
    //Plan1,
    //Plan2,
    //Plan3,
    //Plan4,
    //DonationSlip,
    //WelcomeLetter,
    //EditProfile,
    //EditBankDetails,
    //DonationReceive,
    //RenewRequest,
    //SendDonationReport,
    //ReceiveDonationReport,
    //RegistrationRequestHistory,
    //UpgradeRequest,
    //GenerateSlip,
    //BoosterIncomeWallet,
    //EpinReceiveTransfer,

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    SelectModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      //{ path: 'Home.aspx', component: HomeComponent },
      //{ path: 'MemberExplorer.aspx', component: MemberExplorerComponent },
      //{ path: 'MemberProfile.aspx', component: MemberProfileComponent },
      //{ path: 'GenerateEPin.aspx', component: GenerateEPinComponent },
      //{ path: 'TransferEPin.aspx', component: TransferEPinComponent },
      //{ path: 'BankDetail.aspx', component: BankDetailComponent },
      //{ path: 'ChangePassword.aspx', component: ChangePasswordComponent },
      //{ path: 'MemberChangePassword.aspx', component: MemberChangePasswordComponent },
      //{ path: 'MemberPasswordList.aspx', component: MemberPasswordListComponent },
      //{ path: 'DirectTreeView.aspx', component: DirectTreeViewComponent },
      //{ path: 'TreeView.aspx', component: TreeViewComponent }, 
      //{ path: 'EpinStatus.aspx', component: EpinStatusComponent },
      //{ path: 'MemberActivate.aspx', component: MemberActivateComponent },
      //{ path: 'AllTeam.aspx', component: AllTeamComponent },
      //{ path: 'BinaryMatching.aspx', component: BinaryMatchingComponent },
      //{ path: 'DirectLevelMatching.aspx', component: DirectLevelMatchingComponent },
      //{ path: 'CompanyTurnOver.aspx', component: CompanyTurnOverComponent },
      //{ path: 'WalletHistory.aspx', component: WalletHistory },
      //{ path: 'Payment.aspx', component: Payment },
      //{ path: 'PaymentGOI.aspx', component: PaymentGOI },
      //{ path: 'PaymentHistory.aspx', component: PaymentHistory },
      //{ path: 'GOIIncome.aspx', component: GOIIncome },
      //{ path: 'GOIIncomeMonthly.aspx', component: GOIIncomeMonthly },
      //{ path: 'TDS.aspx', component: TDS }, 
      //{ path: 'RepurchaseWallet.aspx', component: RepurchaseWallet },
      //{ path: 'WithdrawalRequest.aspx', component: WithdrawalRequest },
      //{ path: 'WithdrawalRequestApproval.aspx', component: WithdrawalRequestApproval },
      //{ path: 'WithdrawalHistory.aspx', component: WithdrawalHistory },
      //{ path: 'MemberRegistrationRequest.aspx', component: MemberRegistrationRequest },
      //{ path: 'RegistrationRequestApproval.aspx', component: RegistrationRequestApproval },
      //{ path: 'Plan1.aspx', component: Plan1 },
      //{ path: 'Plan2.aspx', component: Plan2 },
      //{ path: 'Plan3.aspx', component: Plan3 },
      //{ path: 'Plan4.aspx', component: Plan4 },
      //{ path: 'DonationSlip.aspx', component: DonationSlip },
      //{ path: 'DonationReceive.aspx', component: DonationReceive },
      //{ path: 'WelcomeLetter.aspx', component: WelcomeLetter },
      //{ path: 'EditProfile.aspx', component: EditProfile }, 
      //{ path: 'EditBankDetails.aspx', component: EditBankDetails },
      //{ path: 'RenewRequest.aspx', component: RenewRequest },
      //{ path: 'UpgradeRequest.aspx', component: UpgradeRequest },     
      //{ path: 'SendDonationReport.aspx', component: SendDonationReport },
      //{ path: 'ReceiveDonationReport.aspx', component: ReceiveDonationReport },
      //{ path: 'RegistrationRequestHistory.aspx', component: RegistrationRequestHistory },
      //{ path: 'GenerateSlip.aspx', component: GenerateSlip },
      //{ path: 'BoosterIncomeWallet.aspx', component: BoosterIncomeWallet },
      //{ path: 'EpinReceiveTransfer.aspx', component: EpinReceiveTransfer },
      
      


      
      


      
    ])
  ],
  providers: [MemberService, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts